/* Auretto — interactividad del theme (réplica del comportamiento del sitio original) */
(function () {
  'use strict';

  const A = window.Auretto || {};
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* Precio en el mismo formato que el resto del sitio (el filtro Liquid
     `money_without_trailing_zeros`): punto de miles y sin ",00" cuando la
     cifra es redonda. Entra en centavos, que es como viaja todo en Shopify. */
  function money(centavos) {
    const n = (Number(centavos) || 0) / 100;
    const entero = Math.trunc(n);
    const dec = Math.round((n - entero) * 100);
    const conMiles = entero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + conMiles + (dec ? ',' + String(dec).padStart(2, '0') : '');
  }

  /* ─────────────────── toasts ───────────────────
     Igual que el sitio: mensaje + "Podés seguir comprando" + acción "Ver carrito". */
  function toast(msg, opts) {
    opts = opts || {};
    const host = document.getElementById('auretto-toaster');
    if (!host) return;
    const el = document.createElement('div');
    el.className =
      'pointer-events-auto mb-2 flex items-start gap-3 rounded-xl border border-border bg-card ' +
      'px-4 py-3 shadow-lg transition-all duration-300 opacity-0 translate-y-2';
    if (opts.variant === 'error') el.className += ' border-destructive/40';

    const texto = document.createElement('div');
    texto.className = 'flex-1 min-w-0';
    const titulo = document.createElement('p');
    titulo.className = 'text-sm font-medium text-foreground';
    titulo.textContent = msg;
    texto.appendChild(titulo);
    if (opts.description) {
      const desc = document.createElement('p');
      desc.className = 'text-xs text-muted-foreground mt-0.5';
      desc.textContent = opts.description;
      texto.appendChild(desc);
    }
    el.appendChild(texto);

    if (opts.action) {
      const btn = document.createElement('a');
      btn.className =
        'flex-shrink-0 text-xs font-semibold px-3 py-1.5 rounded-lg bg-primary ' +
        'text-primary-foreground hover:opacity-90 transition-all no-underline';
      btn.textContent = opts.action.label;
      btn.href = opts.action.href || '#';
      el.appendChild(btn);
    }

    host.appendChild(el);
    requestAnimationFrame(() => el.classList.remove('opacity-0', 'translate-y-2'));
    setTimeout(() => {
      el.classList.add('opacity-0', 'translate-y-2');
      setTimeout(() => el.remove(), 320);
    }, opts.duration || 2600);
  }

  /* ─────────────────── paneles (menú / búsqueda) ─────────────────── */
  const panel = (name) => $('[data-auretto-panel="' + name + '"]');

  function openMenu() {
    const p = panel('menu');
    if (!p) return;
    p.classList.remove('opacity-0', 'pointer-events-none');
    const sheet = p.querySelector('[class*="translate-x-"]');
    if (sheet) sheet.classList.remove('-translate-x-full');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    const p = panel('menu');
    if (!p) return;
    p.classList.add('opacity-0', 'pointer-events-none');
    const sheet = p.querySelector('[class*="translate-x-"]');
    if (sheet) sheet.classList.add('-translate-x-full');
    document.body.style.overflow = '';
  }

  function openSearch() {
    const p = panel('search');
    if (!p) return;
    p.classList.remove('hidden');
    const input = $('[data-search-input]', p);
    if (input) setTimeout(() => input.focus(), 60);
    document.body.style.overflow = 'hidden';
  }
  function closeSearch() {
    const p = panel('search');
    if (!p) return;
    p.classList.add('hidden');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-auretto]');
    if (!t) return;
    const map = {
      'menu-open': openMenu, 'menu-close': closeMenu,
      'search-open': openSearch, 'search-close': closeSearch,
    };
    const fn = map[t.getAttribute('data-auretto')];
    if (fn) { e.preventDefault(); fn(); }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeMenu(); closeSearch(); }
  });

  /* ─────────────────── menús desplegables del header ─────────────────── */
  $$('[data-dropdown]').forEach((dd) => {
    const trigger = $('[data-dropdown-trigger]', dd);
    const pnl = $('[data-dropdown-panel]', dd);
    if (!trigger || !pnl) return;
    const chev = trigger.querySelector('svg');
    const show = () => {
      pnl.classList.remove('opacity-0', 'invisible', '-translate-y-2');
      if (chev) chev.style.transform = 'rotate(180deg)';
    };
    const hide = () => {
      pnl.classList.add('opacity-0', 'invisible', '-translate-y-2');
      if (chev) chev.style.transform = '';
    };
    dd.addEventListener('mouseenter', show);
    dd.addEventListener('mouseleave', hide);
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      pnl.classList.contains('invisible') ? show() : hide();
    });
    dd.addEventListener('focusout', (e) => {
      if (!dd.contains(e.relatedTarget)) hide();
    });
  });

  /* ─────────────────── header al scrollear ─────────────────── */
  const header = $('[data-auretto-header]');
  if (header) {
    let last = null;
    const onScroll = () => {
      const y = window.scrollY > 20;
      if (y === last) return;
      last = y;
      header.classList.toggle('shadow-sm', y);
      header.classList.toggle('backdrop-blur-md', y);
      header.classList.toggle('border-border/50', y);
      header.classList.toggle('border-transparent', !y);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ─────────────────── galería de las tarjetas de producto ───────────────────
     Las tarjetas del catálogo traían las flechas y los puntitos dibujados desde
     el export de Lovable, pero sin nada detrás: no pasaban las fotos. Además las
     flechas son `opacity-0 group-hover:opacity-100`, así que en el teléfono
     —donde no hay hover— eran invisibles y la única foto que se veía era la
     primera. Acá va la lógica: flechas, puntos y arrastre con el dedo. */
  /* Las fotos ocultas de cada tarjeta viajan en `data-src`/`data-srcset` y se
     bajan recién cuando se las va a mostrar.

     Por qué: cada tarjeta apila 3–4 fotos superpuestas con opacidad. Como todas
     están dentro del viewport, `loading="lazy"` no las frena — el navegador se
     bajaba las 64 del catálogo para mostrar 22. Eran ~2,2 MB de imágenes en una
     página de 3,4 MB, con el 92% del tráfico entrando desde el teléfono: la
     gente veía los recuadros beige vacíos y se iba antes de que aparecieran los
     productos. Se cargan la que se ve y la siguiente (para que el swipe no
     muestre un hueco). */
  function hidratarSlide(img) {
    if (!img) return;
    const ss = img.getAttribute('data-srcset');
    if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-srcset'); }
    const src = img.getAttribute('data-src');
    if (src) { img.setAttribute('src', src); img.removeAttribute('data-src'); }
  }

  function pintarTarjeta(gal, i) {
    const slides = $$('[data-card-slide]', gal);
    if (!slides.length) return;
    const idx = (i + slides.length) % slides.length;
    gal.dataset.cardIndex = idx;
    hidratarSlide(slides[idx]);
    hidratarSlide(slides[(idx + 1) % slides.length]);
    slides.forEach((img, n) => {
      img.classList.toggle('opacity-100', n === idx);
      img.classList.toggle('opacity-0', n !== idx);
    });
    $$('[data-card-dot]', gal).forEach((d, n) => {
      const on = n === idx;
      d.classList.toggle('w-5', on);
      d.classList.toggle('bg-foreground', on);
      d.classList.toggle('w-1.5', !on);
      d.classList.toggle('bg-foreground/40', !on);
      d.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  function moverTarjeta(gal, paso) {
    pintarTarjeta(gal, (parseInt(gal.dataset.cardIndex || '0', 10) || 0) + paso);
  }

  document.addEventListener('click', (e) => {
    const ctrl = e.target.closest('[data-card-prev], [data-card-next], [data-card-dot]');
    if (!ctrl) return;
    const gal = ctrl.closest('[data-card-gallery]');
    if (!gal) return;
    // los controles viven arriba del enlace de la tarjeta: no navegar al producto
    e.preventDefault();
    e.stopPropagation();
    if (ctrl.hasAttribute('data-card-dot')) pintarTarjeta(gal, parseInt(ctrl.getAttribute('data-card-dot'), 10));
    else moverTarjeta(gal, ctrl.hasAttribute('data-card-next') ? 1 : -1);
  });

  /* Arrastre con el dedo. Sólo cuenta como swipe si el gesto es claramente
     horizontal, para no robarle el scroll vertical a la página. */
  $$('[data-card-gallery]').forEach((gal) => {
    if ($$('[data-card-slide]', gal).length < 2) return;
    let x0 = null, y0 = null;
    gal.addEventListener('touchstart', (e) => {
      x0 = e.changedTouches[0].clientX;
      y0 = e.changedTouches[0].clientY;
    }, { passive: true });
    gal.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      const dy = e.changedTouches[0].clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      moverTarjeta(gal, dx < 0 ? 1 : -1);
    }, { passive: true });
  });

  /* ─────────────────── animaciones de entrada al scrollear ─────────────────── */
  const revealables = $$('[data-reveal]');
  if (revealables.length && 'IntersectionObserver' in window) {
    revealables.forEach((el) => el.classList.add('opacity-0', 'translate-y-8'));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('opacity-0', 'translate-y-8');
        entry.target.classList.add('opacity-100', 'translate-y-0');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    revealables.forEach((el) => io.observe(el));
  }

  /* ─────────────────── carrito (AJAX, sin drawer) ─────────────────── */
  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Error del carrito');
    return data;
  }

  /* El ícono del carrito "rebota" al agregar, igual que en el sitio. */
  /* Botón flotante "Finalizar compra": aparece sólo con algo en el carrito.
     Se llama desde bumpCart, así que sigue cualquier cambio (agregar, quitar,
     vaciar) sin recargar la página. */
  /* Las fichas de producto tienen su propia barra fija de compra abajo
     ("$27.500 · 200g · Comprar ahora", `lg:hidden fixed bottom-0`, z-50). El
     botón flotante de finalizar compra cae justo encima y la barra —que tiene
     más z-index— lo tapaba por completo: quedaba invisible en la página donde
     más se usa. Se lo sube por encima de la barra, así conviven: abajo
     "Comprar ahora" (agrega) y arriba "Finalizar compra" (va al carrito). */
  function acomodarBotonCheckout(btn) {
    const barra = $$('.fixed').find((e) => {
      const s = getComputedStyle(e);
      return s.position === 'fixed' && s.display !== 'none' &&
             e !== btn && !e.contains(btn) && $('[data-add-to-cart]', e) &&
             e.getBoundingClientRect().bottom >= window.innerHeight - 2;
    });
    const alto = barra ? Math.round(barra.getBoundingClientRect().height) : 0;
    btn.style.bottom = alto ? alto + 12 + 'px' : '';
  }

  function actualizarBotonCheckout(count) {
    const btn = $('[data-checkout-flotante]');
    if (!btn) return;
    acomodarBotonCheckout(btn);
    const n = $('[data-checkout-flotante-count]', btn);
    if (n) {
      const cambio = n.textContent !== String(count);
      n.textContent = count;
      /* Cuando entra algo al carrito el botón llama la atención UNA vez —dos
         pulsos y se apaga— en vez de moverse todo el tiempo. Es el único
         momento en que el cliente necesita que se lo señalen. */
      if (cambio && count > 0) {
        n.classList.add('aur-pop');
        setTimeout(() => n.classList.remove('aur-pop'), 260);
        btn.classList.remove('aur-llama');
        void btn.offsetWidth; // reinicia la animación si se agrega dos veces seguidas
        btn.classList.add('aur-llama');
        setTimeout(() => btn.classList.remove('aur-llama'), 1600);
      }
    }
    if (count > 0) {
      btn.classList.remove('hidden');
      btn.classList.add('flex');
      // el frame extra deja que el navegador aplique el display antes de animar
      requestAnimationFrame(() => btn.classList.remove('opacity-0', 'translate-y-2'));
    } else {
      btn.classList.add('opacity-0', 'translate-y-2');
      setTimeout(() => {
        if (($('[data-checkout-flotante-count]', btn) || {}).textContent === '0') {
          btn.classList.add('hidden');
          btn.classList.remove('flex');
        }
      }, 300);
    }
  }

  /* Al cargar: el botón viene servido por Liquid ya visible si el carrito
     tiene algo, así que hay que acomodarlo sin esperar a que se agregue nada.
     También al rotar el teléfono, que cambia el alto de la barra de compra. */
  (function () {
    const b = $('[data-checkout-flotante]');
    if (!b) return;
    acomodarBotonCheckout(b);
    let t = null;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(() => acomodarBotonCheckout(b), 150);
    }, { passive: true });
  })();

  function bumpCart(count) {
    actualizarBotonCheckout(count);
    const badge = $('[data-cart-count]');
    if (badge) {
      badge.textContent = count;
      badge.classList.toggle('hidden', count === 0);
    }
    const icon = $('[data-cart-bump]');
    if (!icon) return;
    icon.classList.add('scale-125', 'text-primary', 'bg-primary/15');
    setTimeout(() => icon.classList.remove('scale-125', 'text-primary', 'bg-primary/15'), 600);
  }

  /* ── El 15% de los agregados ──────────────────────────────────────────
     Los frascos que se ofrecen como "Sumá a tu pedido" llevan 15% cuando
     acompañan a otra compra. Se hace con el código SUMA15 y no con un
     descuento automático por una razón concreta: esta tienda ya tiene el
     automático "Mayorista — 3+ baldes", y Shopify aplica UN SOLO descuento
     automático de clase PRODUCT por pedido. Se probó con carritos reales —
     un Basic y un BxGy nuevos quedaron en $0 mientras el mayorista sí
     descontaba. Un código de descuento, en cambio, convive con el automático
     (verificado: combo $99.000 + nocciola $29.900 → $124.415).

     La condición la pone el theme, no Shopify: el requisito de "compra
     mínima" de Shopify mide sólo los productos alcanzados por el descuento,
     así que servía para lo contrario de lo que queremos (le daba el 15% a
     quien compraba dos nocciolas solas y se lo negaba a quien sumaba una a
     un combo). Por eso el mínimo quedó en $1 y la regla vive acá:

         hay un agregado  Y  hay algo más en el carrito  →  15%

     Si el cliente ingresó un código propio (BIENVENIDA10, VOLVE10…) no se
     toca nada: pisárselo con SUMA15 sería sacarle un descuento que ya tenía. */
  const AGREGADOS = ['crema-di-nocciola-200g', 'crema-di-nocciola-400g', 'dulce-de-leche-premium-450g'];
  const CODIGO_AGREGADO = 'SUMA15';

  async function sincronizarDescuentoAgregados(cart) {
    if (!cart || !cart.items) return false;
    const handles = cart.items.map((i) => i.handle);
    const corresponde = handles.some((h) => AGREGADOS.indexOf(h) >= 0) &&
                        handles.some((h) => AGREGADOS.indexOf(h) < 0);
    const codigos = (cart.discount_codes || []).map((d) => d.code);
    const puesto = codigos.indexOf(CODIGO_AGREGADO) >= 0;
    const ajeno = codigos.some((c) => c !== CODIGO_AGREGADO);
    if (ajeno) return false;                       // el código del cliente manda
    if (corresponde === puesto) return false;      // ya está como tiene que estar
    try {
      /* Ruta fija con .js a propósito: A.routes.cart_update viene de Liquid como
         "/cart/update" (sin extensión) y aplicar un código pide la AJAX API. */
      await cartRequest('/cart/update.js', {
        discount: corresponde ? CODIGO_AGREGADO : '',
      });
      return true;
    } catch (_) { return false; }
  }


  /* ── Marcar los upsells que ya están en el carrito ──
     Se aplica a los botones con data-marcable (los de sugerencias), nunca al
     botón principal de compra, que tiene que seguir mostrando su precio. */
  function marcarAgregados(cart) {
    const items = cart && cart.items ? cart.items : [];
    const dentro = new Set(items.map((i) => String(i.variant_id)));
    /* Cuánto hay de cada variante, para los botones que agregan de a varios
       (la escalera de baldes: "Llevar 1" y "Llevar 3" son la MISMA variante).
       Sin esto, llevar 3 marcaba también el botón de 1 y quedaban los dos en
       "Agregado", que es justo lo contrario de aclarar qué elegiste. */
    const cantidad = {};
    items.forEach((i) => { cantidad[String(i.variant_id)] = (cantidad[String(i.variant_id)] || 0) + i.quantity; });

    $$('[data-add-to-cart][data-marcable]').forEach((b) => {
      /* Las filas de upsell llevan su propio estado (cantidad real + quitar),
         que lo pinta `pintarUpsellFilas`. Si acá además se les reescribiera el
         texto a "✓ Agregado", habría dos indicadores diciendo lo mismo y el
         botón perdería su etiqueta. */
      if (b.closest('[data-upsell-fila]')) return;
      const vid = String(b.getAttribute('data-variant-id'));
      const q = parseInt(b.getAttribute('data-qty') || '0', 10);
      let esta = dentro.has(vid);
      if (q > 0) {
        /* Se marca el escalón que de verdad corresponde: el de mayor cantidad
           que entre en lo que hay en el carrito. */
        const hay = cantidad[vid] || 0;
        const hermanos = $$('[data-add-to-cart][data-marcable][data-variant-id="' + vid + '"]')
          .map((x) => parseInt(x.getAttribute('data-qty') || '0', 10))
          .filter((n) => n > 0 && n <= hay);
        esta = hay >= q && Math.max.apply(null, hermanos.concat([0])) === q;
      }
      if (!b.dataset.textoOriginal) b.dataset.textoOriginal = b.textContent.trim();
      if (esta === (b.dataset.marcado === '1')) return;
      b.dataset.marcado = esta ? '1' : '0';
      b.textContent = esta ? '✓ Agregado' : b.dataset.textoOriginal;
      b.classList.toggle('opacity-70', esta);
      /* La tarjeta entera también se marca: en una lista de tres, el borde es
         lo que se ve de reojo sin leer los botones. */
      const tarjeta = b.closest('[data-pack-card]') || b.parentElement.closest('div.flex, div.rounded-xl, div.rounded-2xl');
      if (tarjeta) {
        tarjeta.classList.toggle('ring-2', esta);
        tarjeta.classList.toggle('ring-primary', esta);
      }
    });
  }

  /* ── Filas de upsell: la cantidad a la vista y se saca desde la ficha ──
     (24/9/2026) Las tarjetas de combo de la ficha ERAN el botón: un toque sobre
     el nombre o el precio agregaba otro combo, y tocando cinco veces quedaban
     cinco sin que nada lo dijera —el único cambio era el texto a "✓ Agregado",
     que encima borraba el nombre y el precio de la tarjeta—. Y una vez
     agregado, sacarlo obligaba a ir hasta el carrito.

     Ahora cada fila muestra la cantidad REAL que hay en el pedido y resuelve
     ahí mismo sumar, restar y quitar. Ver `snippets/upsell-cantidad.liquid`. */
  const MAX_UPSELL = 20;

  function lineasDeVariante(cart, vid) {
    const items = cart && cart.items ? cart.items : [];
    return items.filter((i) => String(i.variant_id) === String(vid));
  }

  function pintarUpsellFilas(cart) {
    $$('[data-upsell-fila]').forEach((fila) => {
      const lineas = lineasDeVariante(cart, fila.getAttribute('data-variant-id'));
      const total = lineas.reduce((s, i) => s + i.quantity, 0);
      const hay = total > 0;

      /* Las keys viajan en el dataset porque `cart/change.js` trabaja con la
         LÍNEA, no con la variante: un mismo Combo Duo con sabores distintos son
         dos líneas separadas del carrito. */
      fila.dataset.lineKeys = lineas.map((i) => i.key).join('|');

      const estado = $('[data-upsell-estado]', fila);
      if (estado) {
        estado.classList.toggle('hidden', !hay);
        estado.classList.toggle('flex', hay);
        const n = $('[data-upsell-n]', estado);
        if (n) n.textContent = total;
        const txt = $('[data-upsell-texto]', estado);
        if (txt) txt.textContent = total === 1 ? '1 en tu pedido' : total + ' en tu pedido';
        /* Tope por las dudas: nadie compra 20 combos iguales desde una ficha, y
           si el "+" se queda apretado no se convierte en el mismo problema que
           vinimos a arreglar. */
        const mas = $('[data-upsell-mas]', estado);
        if (mas) {
          const tope = total >= MAX_UPSELL;
          mas.disabled = tope;
          mas.classList.toggle('opacity-40', tope);
          mas.classList.toggle('cursor-not-allowed', tope);
        }
      }

      /* El botón de agregar se esconde cuando ya está en el pedido: el "+" hace
         lo mismo pero mostrando el número. El Combo Duo es la excepción —no
         lleva `data-upsell-agregar`— porque elegir otros dos sabores y sumar un
         segundo Duo es una compra distinta, no un toque de más. */
      const agregar = $('[data-upsell-agregar]', fila);
      if (agregar) agregar.classList.toggle('hidden', hay);

      fila.classList.toggle('ring-2', hay);
      fila.classList.toggle('ring-primary', hay);
    });
  }

  async function refrescarCarrito() {
    let cart = await fetch(A.routes.cart + '.js').then((r) => r.json());
    if (await sincronizarDescuentoAgregados(cart)) {
      cart = await fetch(A.routes.cart + '.js').then((r) => r.json());
    }
    bumpCart(cart.item_count);
    marcarAgregados(cart);
    pintarUpsellFilas(cart);
    // en la página del carrito, recargar para reflejar el cambio
    if (document.querySelector('[data-cart-page]')) window.location.reload();
    return cart;
  }

  /* ── Combos "a elección": selector de sabores ──
     Cada grupo (Sabor #1, Sabor #2…) guarda una elección que viaja
     con el pedido como propiedad de la línea. */
  function pintarGrupo(grupo) {
    $$('[data-flavor]', grupo).forEach((b) => {
      const on = b.hasAttribute('data-flavor-selected');
      b.classList.toggle('border-primary', on);
      b.classList.toggle('bg-primary', on);
      b.classList.toggle('text-primary-foreground', on);
      b.classList.toggle('shadow-soft', on);
      b.classList.toggle('bg-card', !on);
      b.classList.toggle('text-foreground', !on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* El bloque "Incluye" tiene que decir lo mismo que el cliente eligió abajo.
     Cada <span data-incluye-for="Sabor 400g #1"> se reescribe con el sabor
     de ese grupo; si todavía no hay elección, se deja el texto del theme. */
  function sincronizarIncluye() {
    $$('[data-incluye-for]').forEach((span) => {
      const grupo = $(`[data-flavor-group="${span.getAttribute('data-incluye-for')}"]`);
      if (!grupo) return;
      const elegido = $('[data-flavor-selected]', grupo);
      if (!elegido) return;
      const size = span.getAttribute('data-incluye-size') || '';
      span.textContent = `${elegido.getAttribute('data-flavor')} ${size}`.trim();
    });
  }

  $$('[data-flavor-group]').forEach(pintarGrupo);
  sincronizarIncluye();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-flavor]');
    if (!btn) return;
    e.preventDefault();
    const grupo = btn.closest('[data-flavor-group]');
    if (!grupo) return;
    $$('[data-flavor]', grupo).forEach((b) => b.removeAttribute('data-flavor-selected'));
    btn.setAttribute('data-flavor-selected', '');
    pintarGrupo(grupo);
    sincronizarIncluye();
  });

  /* Upsell a combos en la ficha: el Duo "a elección" despliega los selectores
     de sabor en vez de agregar de una con el sabor de la ficha duplicado. */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-upsell-toggle]');
    if (!btn) return;
    e.preventDefault();
    const caja = btn.closest('[data-upsell-combo]');
    const panel = $('[data-upsell-panel]', caja);
    if (!panel) return;
    const abierto = !panel.classList.contains('hidden');
    panel.classList.toggle('hidden', abierto);
    btn.setAttribute('aria-expanded', abierto ? 'false' : 'true');
    if (!abierto) $$('[data-flavor-group]', panel).forEach(pintarGrupo);
  });

  function saboresElegidos(scope) {
    const props = {};
    let faltan = 0;
    $$('[data-flavor-group]', scope || document).forEach((g) => {
      const elegido = $('[data-flavor-selected]', g);
      if (elegido) props[g.getAttribute('data-flavor-group')] = elegido.getAttribute('data-flavor');
      else faltan++;
    });
    return { props, faltan };
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('data-variant-id');
    if (!id) { toast('Producto sin variante configurada', { variant: 'error' }); return; }
    const form = btn.closest('[data-product-form]');
    const qtyInput = form ? $('[data-qty-input]', form) : null;
    const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1
                         : parseInt(btn.getAttribute('data-qty') || '1', 10);
    const nombre = btn.getAttribute('data-product-title') || '';

    let properties;
    // propiedades fijas (ej. el "llevá 2" manda el mismo sabor en los dos lugares)
    const fijas = btn.getAttribute('data-propiedades');
    if (fijas) {
      try { properties = JSON.parse(fijas); } catch (_) {}
    }
    if (btn.hasAttribute('data-requires-flavors')) {
      /* Si el botón vive dentro del panel de upsell, los sabores que valen son
         los de ESE panel: en la ficha de un combo hay otros grupos en la página
         y mezclarlos mandaría al pedido una combinación que nadie eligió. */
      const ambito = btn.closest('[data-upsell-panel]') || document;
      const { props, faltan } = saboresElegidos(ambito);
      if (faltan > 0) {
        toast('Elegí los dos sabores del combo', { variant: 'error' });
        return;
      }
      if (Object.keys(props).length) properties = props;
    }

    /* Combos de surtido fijo con elección OPCIONAL (Triple y Cuádruple).
       Si el cliente abrió el panel y eligió todos los sabores, viajan con el
       pedido. Si no lo tocó, el combo sale con su surtido de siempre y nada
       lo frena: obligar a elegir es justo la fricción que queremos evitar. */
    if (btn.hasAttribute('data-flavors-opcional')) {
      const panel = $('[data-sabores-opcional]');
      const abierto = panel && !$('[data-sabores-panel]', panel).classList.contains('hidden');
      if (abierto) {
        const { props, faltan } = saboresElegidos(panel);
        if (faltan > 0) {
          toast('Te falta elegir ' + faltan + (faltan === 1 ? ' sabor' : ' sabores'), {
            description: 'O cerrá el panel y te mandamos el surtido.',
            variant: 'error',
          });
          return;
        }
        if (Object.keys(props).length) properties = props;
      }
    }

    btn.disabled = true;
    btn.style.opacity = '0.7';
    try {
      const item = { id: Number(id), quantity: qty };
      if (properties) item.properties = properties;
      await cartRequest(A.routes.cart_add, { items: [item] });
      const cartTrasAgregar = await refrescarCarrito();
      /* Caso incómodo: en la ficha de un combo alguien toca "Sumar" en el panel
         de agregados sin agregar el combo. Vio "15% off" y se lleva un carrito
         que no lo tiene. En vez de dejarlo descubrirlo en el checkout, se le
         dice de una y se le explica cómo destrabarlo. */
      const soloAgregados = cartTrasAgregar && cartTrasAgregar.items.length &&
        cartTrasAgregar.items.every((i) => AGREGADOS.indexOf(i.handle) >= 0);
      if (soloAgregados) {
        toast('El 15% se activa al sumarlo a otro producto', {
          description: 'Agregá el combo o un frasco y el descuento se aplica solo.',
        });
      } else {
        toast(nombre ? nombre + ' agregado al carrito' : 'Agregado al carrito', {
          description: 'Podés seguir comprando',
          duration: 2600,
          action: { label: 'Ver carrito', href: A.routes.cart },
        });
      }
    } catch (err) {
      toast(err.message || 'No se pudo agregar', { variant: 'error' });
    } finally {
      btn.disabled = false;
      btn.style.opacity = '';
    }
  });

  /* Sumar, restar y quitar desde la fila del upsell, sin ir al carrito.
     Trabaja sobre las LÍNEAS (`cart/change.js` pide la key) y no sobre la
     variante: un Duo "Clásico + Dubai" y otro "Crock + Crock" son dos líneas
     distintas del mismo producto y no tienen que pisarse. */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-upsell-mas], [data-upsell-menos], [data-upsell-quitar]');
    if (!btn) return;
    e.preventDefault();
    const fila = btn.closest('[data-upsell-fila]');
    if (!fila) return;

    /* Mientras la fila está pidiendo al carrito no acepta otro clic. Es el
       mismo problema de fondo que vinimos a arreglar: cinco toques seguidos no
       pueden valer cinco cambios. Se marca en la fila y no con `disabled` en
       los botones, porque el `disabled` del "+" lo decide el tope en
       `pintarUpsellFilas` y no queremos que uno le pise la decisión al otro. */
    if (fila.dataset.ocupado === '1') return;

    const vid = fila.getAttribute('data-variant-id');
    const nombre = fila.getAttribute('data-product-title') || 'El producto';
    const quitarTodo = btn.hasAttribute('data-upsell-quitar');
    const delta = btn.hasAttribute('data-upsell-mas') ? 1 : -1;

    fila.dataset.ocupado = '1';
    fila.style.opacity = '0.6';
    try {
      let cart = await fetch(A.routes.cart + '.js').then((r) => r.json());
      if (quitarTodo) {
        /* Puede haber más de una línea de la misma variante (el Duo con dos
           combinaciones de sabores): se sacan todas, releyendo el carrito entre
           una y otra porque cada cambio reacomoda las líneas. El tope de vueltas
           es un seguro: sin él, un error del carrito dejaría el bucle girando. */
        for (let i = 0; i < 12; i++) {
          const linea = lineasDeVariante(cart, vid)[0];
          if (!linea) break;
          await cartRequest(A.routes.cart_change, { id: linea.key, quantity: 0 });
          cart = await fetch(A.routes.cart + '.js').then((r) => r.json());
        }
      } else {
        const lineas = lineasDeVariante(cart, vid);
        const linea = lineas[lineas.length - 1];
        if (!linea) return;
        await cartRequest(A.routes.cart_change, {
          id: linea.key,
          quantity: Math.max(0, Math.min(MAX_UPSELL, linea.quantity + delta)),
        });
      }
      /* refrescarCarrito revisa además el 15% de los agregados: sacar el último
         combo tiene que sacar también el descuento que lo acompañaba. */
      const nuevo = await refrescarCarrito();
      const quedan = lineasDeVariante(nuevo, vid).reduce((s, i) => s + i.quantity, 0);
      toast(quedan ? nombre + ': ' + quedan + ' en tu pedido' : nombre + ' — sacado del pedido', {
        duration: 2200,
        action: quedan ? { label: 'Ver carrito', href: A.routes.cart } : null,
      });
    } catch (err) {
      toast(err.message || 'No se pudo actualizar', { variant: 'error' });
    } finally {
      fila.dataset.ocupado = '';
      fila.style.opacity = '';
    }
  });

  /* ── Tarjetas de balde del catálogo: cantidad y precio coherente ──
     El balde tiene dos variantes: $196.000 la unidad y $156.000 desde 3. La
     tarjeta mostraba el precio MENOR ($156.000) y después el carrito cobraba
     $196.000, porque el botón agregaba la otra variante. Acá se corrige de
     raíz: el total se calcula con el precio que corresponde a la cantidad
     elegida, y al agregar se manda la variante de ese mismo precio. Lo que ve
     el cliente es lo que paga. */
  /* Un solo lugar para el mínimo mayorista: la tarjeta, el widget surtido y la
     revalidación del carrito tienen que coincidir siempre. Cuando eran dos
     constantes distintas (3 y 3) alcanzaba con tocar una para que la tienda
     prometiera un precio que el carrito no cobraba. */
  const MIN_BALDES = 3;
  /* Tope alto a propósito: desde que la cantidad se elige por sabor, un número
     grande no ensucia la pantalla. Con 12 no se llegaba ni al escalón de 25. */
  const MAX_BALDES = 99;

  /* ── La escalera mayorista, en un solo lugar (14/9/2026) ──
     1-2 unitario · 3-9 · 10-24 · 25+. Los precios ya vienen calculados desde
     Liquid en el mapa de variantes, con el mismo descuento que cobra el
     automático de Shopify. Antes el widget sumaba siempre el precio de 3+, así
     que un pedido de 10 o de 25 se anunciaba más caro de lo que iba a cobrar
     el checkout. El corte se lee de acá y de ningún otro lado. */
  const ESCALONES_BALDE = [
    { min: 25, campo: 'precio25' },
    { min: 10, campo: 'precio10' },
    { min: MIN_BALDES, campo: 'precio' },
  ];

  function precioBalde(v, n) {
    if (!v) return 0;
    for (let i = 0; i < ESCALONES_BALDE.length; i++) {
      const e = ESCALONES_BALDE[i];
      if (n >= e.min) return Number(v[e.campo]) || Number(v.precio) || 0;
    }
    return Number(v.precio_unit) || Number(v.precio) || 0;
  }

  function variantesBaldes() {
    const datos = $('[data-balde-variantes]');
    try { return JSON.parse(datos ? datos.textContent : '{}'); } catch (_) { return {}; }
  }

  function pintarTarjetaBalde(card) {
    const handle = card.getAttribute('data-balde-card');
    const cont = card.closest('article') || card.parentElement;
    const qtyEl = $('[data-balde-qty]', cont);
    const n = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
    const v = variantesBaldes()[handle];
    if (!v) return;

    const unit = precioBalde(v, n);
    const total = unit * n;

    const elN = $('[data-balde-card-n]', card);
    if (elN) elN.textContent = n;
    const elL = $('[data-balde-card-lbl]', card);
    if (elL) elL.textContent = n === 1 ? 'balde' : 'baldes';
    const elT = $('[data-balde-card-total]', card);
    if (elT) elT.textContent = money(total);

    const menos = $('[data-balde-menos]', cont);
    if (menos) menos.disabled = n <= 1;

    /* El botón agrega la variante que corresponde a la cantidad: con 3 o más
       va la mayorista, y así el carrito coincide con el total mostrado. */
    const add = $('[data-add-to-cart]', cont);
    if (add) {
      add.setAttribute('data-variant-id', n >= MIN_BALDES ? v.id : v.id_unit);
      add.setAttribute('data-qty', n);
    }
  }

  document.addEventListener('click', (e) => {
    const ctrl = e.target.closest('[data-balde-mas], [data-balde-menos]');
    if (!ctrl) return;
    e.preventDefault();
    const cont = ctrl.closest('article') || ctrl.parentElement;
    const qtyEl = $('[data-balde-qty]', cont);
    const card = $('[data-balde-card]', cont);
    if (!qtyEl || !card) return;
    let n = parseInt(qtyEl.textContent, 10) || 1;
    n += ctrl.hasAttribute('data-balde-mas') ? 1 : -1;
    if (n < 1) n = 1;
    if (n > 20) n = 20;
    qtyEl.textContent = n;
    pintarTarjetaBalde(card);
  });

  $$('[data-balde-card]').forEach(pintarTarjetaBalde);

  /* ── Guarda del precio mayorista de baldes ──
     **Quién aplica el descuento mayorista: NO este archivo.** Lo aplica un
     descuento automático de Shopify ("Mayorista — 3+ baldes a $156.000 c/u",
     −$40.000 por unidad desde 3 baldes, sobre los 4 productos balde). Al ser
     server-side, corre en TODOS los caminos —fichas sueltas, tarjetas, widget
     surtido, sabores mezclados— sin depender de que el JS cargue, y no se puede
     burlar. Ese es el mecanismo bueno; no duplicarlo acá.

     Lo único que queda de este lado es la guarda hacia abajo: se podían agregar
     3 baldes (entra la variante "3+ baldes · precio mayorista"), bajar la
     cantidad a 1 en el carrito y quedarse con un balde de esa variante. Hoy las
     dos variantes valen lo mismo, así que no hay agujero de plata; la guarda
     queda como red por si alguna vez se le vuelve a poner precio propio a la
     variante mayorista.

     **No agregar acá un "upgrade" de variante unitaria → mayorista.** Ya se
     intentó: es redundante con el descuento automático y, al hacer add + remove
     sobre el carrito mientras la página navega, puede correr dos veces y
     duplicar los baldes del cliente. */
  async function revalidarBaldesDelCarrito() {
    if (!$('[data-cart-page]')) return;
    const datos = variantesBaldes();
    const porMayorista = {};
    Object.values(datos).forEach((v) => { if (v.id) porMayorista[v.id] = v.id_unit; });
    if (!Object.keys(porMayorista).length) return;

    let cart;
    try { cart = await fetch(A.routes.cart + '.js').then((r) => r.json()); } catch (_) { return; }
    const lineas = cart.items.filter((i) => porMayorista[i.variant_id]);
    const total = lineas.reduce((a, i) => a + i.quantity, 0);
    if (!lineas.length || total >= MIN_BALDES) return;

    let movidas = 0;
    for (const linea of lineas) {
      const unit = porMayorista[linea.variant_id];
      if (!unit) continue;
      /* Se agrega la línea nueva ANTES de sacar la vieja: si el alta falla, el
         cliente conserva su balde. Al revés se le vaciaba el carrito sin aviso. */
      try {
        await cartRequest(A.routes.cart_add, {
          items: [{ id: Number(unit), quantity: linea.quantity, properties: linea.properties || {} }],
        });
      } catch (_) { continue; }
      try { await cartRequest(A.routes.cart_change, { id: linea.key, quantity: 0 }); } catch (_) {}
      movidas++;
    }
    if (!movidas) return;

    /* El aviso viaja en sessionStorage porque abajo se recarga la página: el
       toast se dibujaba y moría en la misma línea, así que el cliente veía
       cambiar el total sin que nadie le explicara por qué. */
    avisoBaldes({
      titulo: 'El precio mayorista es desde ' + MIN_BALDES + ' baldes',
      desc: 'Ajustamos tu pedido al precio por unidad.',
    });
    window.location.reload();
  }

  /* Deja pendiente un aviso para después de la recarga, o lo muestra si ya
     quedó uno pendiente de la vuelta anterior. */
  function avisoBaldes(pendiente) {
    let store;
    try { store = window.sessionStorage; } catch (_) { return; }
    if (pendiente) {
      try { store.setItem('aur_baldes_aviso', JSON.stringify(pendiente)); } catch (_) {}
      return;
    }
    let dato;
    try {
      dato = store.getItem('aur_baldes_aviso');
      store.removeItem('aur_baldes_aviso');
    } catch (_) { return; }
    if (!dato) return;
    try {
      const a = JSON.parse(dato);
      toast(a.titulo, { description: a.desc, duration: 6000 });
    } catch (_) {}
  }

  /* ── Widget mayorista: pedido surtido de baldes ──
     El bloque promete "podés comprar 3, 4, 5 o más", pero los botones + y −
     venían del export de Lovable sin nada detrás: no sumaban baldes, no
     aparecían más selectores y el total y el ahorro eran texto fijo. Acá va la
     lógica completa; el mínimo son 3 porque debajo de eso no corre el precio
     mayorista. */
  function baldesDelWidget(w) {
    /* Una fila por sabor con su propia cantidad. Antes había un select por
       balde: con el escalón de 25 eso eran 25 desplegables idénticos en
       pantalla, imposible de usar y peor de leer. Elegir "cuántos de cada uno"
       es además como piensa el mayorista. */
    return $$('[data-bfila]', w).map((fila) => {
      const el = $('[data-bfila-n]', fila);
      return {
        fila: fila,
        handle: fila.getAttribute('data-bfila-handle'),
        n: parseInt(el ? el.textContent : '0', 10) || 0,
        el: el,
      };
    });
  }

  function pintarWidgetBaldes(w) {
    const filas = baldesDelWidget(w);
    const vars = variantesBaldes();
    const n = filas.reduce((a, f) => a + f.n, 0);

    let total = 0, lista = 0;
    filas.forEach((f) => {
      const v = vars[f.handle];
      if (!v || !f.n) return;
      /* El ahorro se mide contra el precio unitario real ($196.000). Se lee
         `precio_unit`, que viaja en los dos mapas de variantes (el de la tienda
         y el del carrito); `precio_lista` sólo lo emite la tienda y vale lo
         mismo. */
      total += precioBalde(v, n) * f.n;
      lista += (Number(v.precio_unit) || Number(v.precio) || 0) * f.n;
    });
    const ahorro = lista - total;

    const elN = $('[data-baldes-cantidad]', w);
    if (elN) elN.textContent = n;
    const elBtn = $('[data-baldes-btn-n]', w);
    if (elBtn) elBtn.textContent = n;
    const elTit = $('[data-baldes-titulo-n]', w);
    if (elTit) elTit.textContent = n;
    const elTotal = $('[data-baldes-total]', w);
    if (elTotal) elTotal.textContent = 'Total: ' + money(total);
    const elAhorro = $('[data-baldes-ahorro]', w);
    if (elAhorro) elAhorro.textContent = ahorro > 0 ? 'Ahorrás ' + money(ahorro) : '';

    /* El precio del escalón vigente: al pasar de 9 a 10 —o de 24 a 25— el
       cartel tiene que bajar solo. */
    const unitario = n > 0 ? Math.round(total / n) : 0;
    const elUnit = $('[data-baldes-unit]', w);
    if (elUnit && unitario) elUnit.textContent = money(unitario);
    const elKilo = $('[data-baldes-kilo]', w);
    if (elKilo && unitario) elKilo.textContent = money(Math.round(unitario / 4));

    /* Cuánto falta para el escalón siguiente. Es el argumento que sube el
       pedido: el mayorista no sabe que a 10 baldes el kilo le baja $6.000. */
    const aviso = $('[data-baldes-falta]', w);
    if (aviso) {
      const ref = vars['balde-pistacho-clasico-4kg'];
      let txt = '';
      if (n > 0 && n < MIN_BALDES) {
        txt = 'Mínimo ' + MIN_BALDES + ' baldes para el precio mayorista.';
      } else if (ref) {
        /* del escalón más chico al más grande, el primero que todavía no alcanzó */
        for (let i = ESCALONES_BALDE.length - 1; i >= 0; i--) {
          const e = ESCALONES_BALDE[i];
          if (n < e.min) {
            const kilo = Math.round((Number(ref[e.campo]) || 0) / 4);
            if (kilo) txt = 'Sumá ' + (e.min - n) + ' baldes más y el kilo baja a ' + money(kilo) + '.';
            break;
          }
        }
      }
      aviso.textContent = txt;
    }

    filas.forEach((f) => {
      const menos = $('[data-bfila-menos]', f.fila);
      if (menos) menos.disabled = f.n <= 0;
      const mas = $('[data-bfila-mas]', f.fila);
      if (mas) mas.disabled = n >= MAX_BALDES;
      f.fila.classList.toggle('border-primary/50', f.n > 0);
      f.fila.classList.toggle('bg-primary/5', f.n > 0);
    });

    const btn = $('[data-add-baldes]', w);
    if (btn) btn.disabled = n < MIN_BALDES;
  }

  document.addEventListener('click', (e) => {
    const ctrl = e.target.closest('[data-bfila-mas], [data-bfila-menos]');
    if (!ctrl) return;
    e.preventDefault();
    const w = ctrl.closest('[data-baldes-widget]');
    const fila = ctrl.closest('[data-bfila]');
    if (!w || !fila) return;
    const el = $('[data-bfila-n]', fila);
    if (!el) return;
    const actual = parseInt(el.textContent, 10) || 0;
    const total = baldesDelWidget(w).reduce((a, f) => a + f.n, 0);

    if (ctrl.hasAttribute('data-bfila-mas')) {
      if (total >= MAX_BALDES) return;
      el.textContent = actual + 1;
    } else {
      if (actual <= 0) return;
      el.textContent = actual - 1;
    }
    pintarWidgetBaldes(w);
  });

  $$('[data-baldes-widget]').forEach(pintarWidgetBaldes);

  /* Al cargar, marcar lo que ya esté en el carrito: quien vuelve a la ficha
     tiene que ver de una qué había sumado. */
  (async function marcarAlAbrir() {
    if (!$('[data-add-to-cart][data-marcable]') && !$('[data-upsell-fila]')) return;
    try {
      const cart = await fetch(A.routes.cart + '.js').then((r) => r.json());
      marcarAgregados(cart);
      /* Sin esto, quien vuelve a la ficha con dos combos ya en el carrito veía
         la fila como si no hubiera sumado nada y agregaba un tercero. */
      pintarUpsellFilas(cart);
    } catch (_) {}
  })();

  /* Al abrir el carrito, revisar que el precio mayorista corresponda. */
  avisoBaldes();
  revalidarBaldesDelCarrito();

  /* …y que el 15% de los agregados esté como corresponde. Cubre el carrito que
     viene de otra visita o de otro dispositivo, donde nadie tocó un botón.
     Recarga sólo si hubo un cambio real, así que no puede entrar en bucle. */
  (async function revisarDescuentoAlAbrirElCarrito() {
    if (!$('[data-cart-page]')) return;
    try {
      const cart = await fetch(A.routes.cart + '.js').then((r) => r.json());
      if (await sincronizarDescuentoAgregados(cart)) window.location.reload();
    } catch (_) {}
  })();

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-baldes]');
    if (!btn) return;
    e.preventDefault();
    const w = btn.closest('[data-baldes-widget]') || document;
    const vars = variantesBaldes();

    /* Un renglón de carrito por sabor, con su cantidad: 12 Clásico + 13 Dubai
       entran como dos líneas, no como 25. */
    const items = [];
    let n = 0;
    baldesDelWidget(w).forEach((f) => {
      const v = vars[f.handle];
      if (v && v.id && f.n > 0) { items.push({ id: Number(v.id), quantity: f.n }); n += f.n; }
    });
    if (n < MIN_BALDES) {
      toast('Elegí al menos ' + MIN_BALDES + ' baldes', { variant: 'error' });
      return;
    }
    btn.disabled = true;
    btn.style.opacity = '0.7';
    try {
      await cartRequest(A.routes.cart_add, { items: items });
      await refrescarCarrito();
      toast(n + ' baldes agregados al carrito', {
        description: 'Precio mayorista aplicado',
        action: { label: 'Ver carrito', href: A.routes.cart },
      });
    } catch (err) {
      toast(err.message || 'No se pudo agregar', { variant: 'error' });
    } finally {
      btn.disabled = false;
      btn.style.opacity = '';
    }
  });

  // cambios de cantidad en la página del carrito
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    try {
      await cartRequest(A.routes.cart_change, {
        id: btn.getAttribute('data-cart-qty'),
        quantity: parseInt(btn.getAttribute('data-qty'), 10),
      });
      /* Sacar el último combo tiene que sacar también el 15% del agregado que
         lo acompañaba: si no, quedaba un carrito de puros agregados con un
         descuento que ya no le corresponde. */
      try { await sincronizarDescuentoAgregados(await fetch(A.routes.cart + '.js').then((r) => r.json())); } catch (_) {}
      window.location.reload();
    } catch (err) {
      toast(err.message || 'No se pudo actualizar', { variant: 'error' });
      btn.disabled = false;
    }
  });

  /* ── Barra de compra fija en celular ──
     Se muestra sólo mientras el botón real está fuera de la pantalla. Usa
     IntersectionObserver y no scroll listeners: el navegador avisa cuando el
     botón entra o sale, sin correr código en cada píxel de scroll. */
  (function barraCompraMovil() {
    const barra = $('[data-barra-compra]');
    if (!barra) return;
    const real = $('[data-product-form] [data-add-to-cart]') ||
                 $$('[data-add-to-cart]').find((b) => /Agregar|Comprar/i.test(b.textContent));
    if (!real) return;
    const pildora = $('[data-checkout-flotante]');

    const mostrar = (si) => {
      barra.classList.toggle('translate-y-full', !si);
      barra.classList.toggle('opacity-0', !si);
      /* La píldora "Finalizar compra" vive en la misma esquina: si conviven,
         se tapan entre ellas y no se puede tocar ninguna de las dos. */
      if (pildora) pildora.style.visibility = si ? 'hidden' : '';
    };
    mostrar(false);

    new IntersectionObserver(
      (entradas) => entradas.forEach((e) => mostrar(!e.isIntersecting)),
      { rootMargin: '0px 0px -80px 0px' }
    ).observe(real);

    /* En los combos "a elección" la barra no agrega: lleva a elegir los sabores. */
    barra.addEventListener('click', (e) => {
      if (!e.target.closest('[data-barra-elegir]')) return;
      const grupo = $('[data-flavor-group]');
      if (grupo) {
        (grupo.closest('div') || grupo).scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        real.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  })();

  /* Panel de sabores opcional: se abre a pedido y no bloquea nada. */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-sabores-toggle]');
    if (!t) return;
    e.preventDefault();
    const caja = t.closest('[data-sabores-opcional]');
    const panel = $('[data-sabores-panel]', caja);
    const chevron = $('[data-sabores-chevron]', caja);
    const abierto = !panel.classList.contains('hidden');
    panel.classList.toggle('hidden', abierto);
    if (chevron) chevron.classList.toggle('rotate-180', !abierto);
  });

  /* ── Escalera de packs ──
     La tarjeta entera lleva a la ficha del combo, salvo que el clic haya sido
     sobre el botón "Sumar", que agrega al carrito sin moverse de la página.
     No se usa un <a> envolvente porque adentro hay un <button>, y un botón
     dentro de un enlace es HTML inválido: el navegador lo saca del enlace y
     deja de responder al clic. */
  function irAlPack(card) {
    const url = card.getAttribute('data-pack-url');
    if (url) window.location.href = url;
  }
  document.addEventListener('click', (e) => {
    const card = e.target.closest('[data-pack-card]');
    if (!card || e.target.closest('[data-add-to-cart]')) return;
    irAlPack(card);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const card = e.target.closest('[data-pack-card]');
    if (!card || e.target.closest('[data-add-to-cart]')) return;
    e.preventDefault();
    irAlPack(card);
  });

  /* ─────────────────── selector de cantidad ─────────────────── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    const form = btn.closest('[data-product-form]') || document;
    const input = $('[data-qty-input]', form);
    if (!input) return;
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ─────────────────── galería de producto ─────────────────── */
  $$('[data-gallery]').forEach((gal) => {
    const slides = $$('[data-gallery-slide]', gal);
    const thumbs = $$('[data-gallery-thumb]', gal);
    if (!slides.length) return;
    let index = 0;
    /* Deslizar la foto con el dedo, igual que en las tarjetas del catálogo.
       Sólo cuenta como swipe si el movimiento es claramente horizontal, para no
       robarle el scroll vertical a la página. */
    if (slides.length > 1) {
      let x0 = null, y0 = null;
      gal.addEventListener('touchstart', (e) => {
        x0 = e.changedTouches[0].clientX;
        y0 = e.changedTouches[0].clientY;
      }, { passive: true });
      gal.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        const dy = e.changedTouches[0].clientY - y0;
        x0 = y0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        index = (index + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
        render();
      }, { passive: true });
    }

    const render = () => {
      slides.forEach((s, i) => {
        s.classList.toggle('opacity-100', i === index);
        s.classList.toggle('opacity-0', i !== index);
        /* El video es un slide más, pero pesa 4,4 MB: va con `preload="none"`,
           así que recién se baja cuando el cliente entra a su slide. Al salir se
           pausa —si no, sigue corriendo detrás de las fotos gastando datos— y se
           rebobina para que la próxima vez arranque desde el principio. */
        if (s.tagName !== 'VIDEO') return;
        if (i === index) {
          const p = s.play();
          if (p && p.catch) p.catch(() => {}); // el navegador puede bloquearlo: no romper la galería
        } else {
          s.pause();
          if (s.currentTime) s.currentTime = 0;
        }
      });
      thumbs.forEach((t, i) => {
        t.classList.toggle('opacity-100', i === index);
        t.classList.toggle('opacity-70', i !== index);
        t.classList.toggle('ring-2', i === index);
        t.classList.toggle('ring-primary', i === index);
      });
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => { index = i; render(); }));
    const go = (d) => { index = (index + d + slides.length) % slides.length; render(); };
    $$('[data-gallery-prev]', gal).forEach((b) => b.addEventListener('click', () => go(-1)));
    $$('[data-gallery-next]', gal).forEach((b) => b.addEventListener('click', () => go(1)));
    // teclado: flechas cuando la galería tiene foco
    gal.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
    render();

    /* ── Ampliar la foto ──
       Las 22 fichas traían del export de Lovable el botón de lupa ("Ver imagen
       ampliada") y un `cursor-zoom-in` sobre la foto, pero **sin nada detrás**:
       el cliente tocaba para ver el producto de cerca y no pasaba nada. En
       Clarity eso aparecía como 5,9% de "clics fallidos" — 120 sesiones en 3
       días tocando algo que no respondía, y en un producto que se compra por la
       textura, ver la foto grande es parte de la decisión.

       El overlay se arma por JS y con estilos en línea a propósito: el CSS del
       theme es un build de Tailwind que sólo incluye las clases que ya se
       usaban, así que una clase nueva no existiría en la hoja. */
    const fotos = slides.filter((s) => s.tagName === 'IMG');
    if (fotos.length) {
      let visor = null;
      let iZoom = 0;

      const pintarZoom = () => {
        const img = fotos[iZoom];
        visor.querySelector('[data-zoom-img]').src = img.currentSrc || img.src;
        const nav = visor.querySelector('[data-zoom-nav]');
        if (nav) nav.textContent = fotos.length > 1 ? (iZoom + 1) + ' / ' + fotos.length : '';
      };

      const cerrar = () => {
        if (!visor) return;
        visor.remove();
        visor = null;
        document.body.style.overflow = '';
      };

      const moverZoom = (d) => {
        iZoom = (iZoom + d + fotos.length) % fotos.length;
        pintarZoom();
      };

      const abrir = (desde) => {
        iZoom = Math.max(0, fotos.indexOf(desde));
        visor = document.createElement('div');
        visor.setAttribute('role', 'dialog');
        visor.setAttribute('aria-label', 'Foto ampliada');
        visor.style.cssText = 'position:fixed;inset:0;z-index:120;background:rgba(28,16,10,.94);' +
          'display:flex;align-items:center;justify-content:center;padding:16px;cursor:zoom-out';
        visor.innerHTML =
          '<img data-zoom-img alt="" style="max-width:100%;max-height:92vh;object-fit:contain;' +
            'border-radius:12px;cursor:default">' +
          '<button data-zoom-cerrar aria-label="Cerrar" style="position:absolute;top:14px;right:14px;' +
            'width:40px;height:40px;border:0;border-radius:999px;background:rgba(255,255,255,.92);' +
            'font-size:22px;line-height:1;cursor:pointer">&times;</button>' +
          (fotos.length > 1
            ? '<button data-zoom-prev aria-label="Anterior" style="position:absolute;left:10px;top:50%;' +
                'transform:translateY(-50%);width:44px;height:44px;border:0;border-radius:999px;' +
                'background:rgba(255,255,255,.92);font-size:20px;cursor:pointer">&#8249;</button>' +
              '<button data-zoom-next aria-label="Siguiente" style="position:absolute;right:10px;top:50%;' +
                'transform:translateY(-50%);width:44px;height:44px;border:0;border-radius:999px;' +
                'background:rgba(255,255,255,.92);font-size:20px;cursor:pointer">&#8250;</button>' +
              '<span data-zoom-nav style="position:absolute;bottom:16px;left:50%;transform:translateX(-50%);' +
                'color:#fff;font-size:13px;letter-spacing:.08em"></span>'
            : '');
        document.body.appendChild(visor);
        document.body.style.overflow = 'hidden';
        pintarZoom();

        visor.addEventListener('click', (e) => {
          if (e.target.closest('[data-zoom-prev]')) { moverZoom(-1); return; }
          if (e.target.closest('[data-zoom-next]')) { moverZoom(1); return; }
          if (e.target.closest('[data-zoom-cerrar]')) { cerrar(); return; }
          // tocar la foto no cierra; tocar el fondo sí
          if (!e.target.closest('[data-zoom-img]')) cerrar();
        });

        /* En el teléfono —el 92% del tráfico— se pasa de foto arrastrando. */
        let x0 = null;
        visor.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
        visor.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 45) moverZoom(dx < 0 ? 1 : -1);
          x0 = null;
        }, { passive: true });
      };

      document.addEventListener('keydown', (e) => {
        if (!visor) return;
        if (e.key === 'Escape') cerrar();
        if (e.key === 'ArrowLeft') moverZoom(-1);
        if (e.key === 'ArrowRight') moverZoom(1);
      });

      fotos.forEach((img) => img.addEventListener('click', () => abrir(img)));
      /* El botón de la lupa abre la foto que se está viendo. */
      $$('button', gal).forEach((b) => {
        const et = (b.getAttribute('aria-label') || '') + b.className;
        if (/ampliada|zoom/i.test(et)) {
          b.addEventListener('click', (e) => {
            e.preventDefault();
            const visible = fotos.find((f) => f.classList.contains('opacity-100')) || fotos[0];
            abrir(visible);
          });
        }
      });
    }
  });

  /* ─────────────────── reseñas que se van turnando ───────────────────
     Antes era un carrusel con scroll al costado y no servía: nadie descubre
     que hay más reseñas si no se ve que haya algo corrido a la derecha. Ahora
     se muestra una sola, completa, y cada tanto entra la siguiente.

     Las tarjetas están todas en el HTML, apiladas en la misma celda del grid;
     acá sólo se cambia cuál es la visible. Así no hay que pedir nada al
     servidor ni armar nodos al vuelo.

     Se frena cuando el cliente pasa el mouse o toca: si estaba leyendo una
     reseña, cambiarla en la mitad es peor que no rotar.

     Con "reducir movimiento" activado sigue rotando, pero sin el fundido: lo
     que molesta de las animaciones es el movimiento, no que cambie el texto.
     Si se cortara la rotación, esa persona vería una sola reseña de todas. */
  $$('[data-resenas]').forEach((bloque) => {
    const tarjetas = $$('[data-resena]', bloque);
    if (tarjetas.length < 2) return;
    const puntos = $$('[data-resenas-puntos] span', bloque);
    const quieto = window.matchMedia('(prefers-reduced-motion: reduce)');

    let i = 0, timer = null, pausado = false;

    /* Cuánto queda cada reseña en pantalla. Se probó con 1,5 s y era muy poco:
       las reseñas rondan los 150 caracteres y leer eso lleva unos 5 segundos,
       así que el cliente veía que algo cambiaba pero no llegaba a terminar
       ninguna. A 5 s alcanza a leerla completa y todavía ve varias mientras
       decide. */
    const CADA = 5000;

    const pintar = () => {
      tarjetas.forEach((t, n) => {
        const on = n === i;
        t.classList.toggle('opacity-100', on);
        t.classList.toggle('opacity-0', !on);
        t.classList.toggle('pointer-events-none', !on);
        if (on) t.removeAttribute('aria-hidden');
        else t.setAttribute('aria-hidden', 'true');
      });
      /* Los puntitos son pocos aunque haya 45 reseñas: marcan el avance, no
         cuentan una por una. */
      if (puntos.length) {
        const activo = i % puntos.length;
        /* Los puntitos se estilan en línea, no con clases: el CSS del theme es
           un build que sólo trae las clases ya usadas, y las arbitrarias
           (w-1.5, bg-primary/25) no existen — el punto quedaría sin tamaño. */
        puntos.forEach((p, n) => {
          const on = n === activo;
          p.style.width = on ? '16px' : '6px';
          p.style.background = on ? '#5c3b2a' : 'rgba(92,59,42,.25)';
        });
      }
    };

    const paso = () => {
      if (pausado) return;
      i = (i + 1) % tarjetas.length;
      pintar();
    };

    const arrancar = () => { if (!timer) timer = setInterval(paso, CADA); };
    const parar = () => { if (timer) { clearInterval(timer); timer = null; } };

    bloque.addEventListener('mouseenter', () => { pausado = true; });
    bloque.addEventListener('mouseleave', () => { pausado = false; });
    bloque.addEventListener('touchstart', () => {
      pausado = true;
      setTimeout(() => { pausado = false; }, 6000);
    }, { passive: true });

    /* Sólo corre mientras está a la vista. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((es) => {
        es.forEach((e) => (e.isIntersecting ? arrancar() : parar()));
      }, { threshold: 0.3 }).observe(bloque);
    } else {
      arrancar();
    }
  });

  /* ─────────────────── acordeones (FAQ) ─────────────────── */
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    e.preventDefault();
    const item = trigger.closest('[data-accordion-item]') || trigger.parentElement;
    const body = $('[data-accordion-body]', item);
    if (!body) return;
    const open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
    body.classList.toggle('hidden', open);
    const chev = trigger.querySelector('svg');
    if (chev) chev.classList.toggle('rotate-180', !open);
  });

  /* ─────────────────── búsqueda ─────────────────── */
  const searchInput = $('[data-search-input]');
  if (searchInput) {
    let timer;
    searchInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = searchInput.value.trim();
      const box = $('[data-search-results]');
      if (!box) return;
      if (q.length < 2) { box.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          const url = A.routes.predictive_search + '?q=' + encodeURIComponent(q) +
            '&resources[type]=product,page&resources[limit]=6&section_id=predictive-search';
          const res = await fetch(url);
          if (!res.ok) throw new Error('sin resultados');
          box.innerHTML = await res.text();
        } catch (_) {
          box.innerHTML = '<p class="py-6 text-sm text-muted-foreground">Presioná Enter para buscar.</p>';
        }
      }, 250);
    });
  }

  /* ── Estrellas del formulario de opinión ── */
  $$('[data-estrellas]').forEach((grupo) => {
    const campo = document.getElementById('op-estrellas');
    const pintar = (n) => $$('[data-estrella]', grupo).forEach((b) => {
      const svg = b.querySelector('svg');
      const activa = parseInt(b.getAttribute('data-estrella'), 10) <= n;
      svg.style.fill = activa ? 'currentColor' : 'none';
      b.setAttribute('aria-pressed', activa ? 'true' : 'false');
    });
    $$('[data-estrella]', grupo).forEach((b) => {
      b.addEventListener('click', () => {
        const n = parseInt(b.getAttribute('data-estrella'), 10);
        if (campo) campo.value = n;
        pintar(n);
      });
      b.addEventListener('mouseenter', () => pintar(parseInt(b.getAttribute('data-estrella'), 10)));
    });
    grupo.addEventListener('mouseleave', () => pintar(parseInt(campo ? campo.value : 5, 10)));
    pintar(5);
  });

  window.AurettoUI = { openMenu, closeMenu, openSearch, closeSearch, toast, bumpCart };
})();
